import React, { useContext } from "react";
import HeaderText from "../../components/headerText";
import ReviewList from "../../components/ReviewList";
import ReviewTags from "../../components/ReviewTags";
import { Star } from "../../components/StarRating";
import PlatformIcons from "../../logos/social";
import { AppContext } from "./";

const PlatformIcon = ({ platform }) => {
  return <img src={PlatformIcons[platform]} />;
};

const Counts = ({ merchant }) => {
  return <div className="count">{merchant.numReviews} Ratings & Reviews</div>;
};

const FilterControls = ({ currentFilter, setFilter, merchant }) => {
  const manager = merchant.thirdPartyStatus;
  const { aggregates } = merchant;

  if (!aggregates) {
    return (
      <div className="filter-bar">
        <Counts merchant={merchant} />
      </div>
    );
  }

  const { google, facebook } = aggregates;
  let { numReviews, averageRating } = merchant;

  if (!averageRating) {
    averageRating = 0.0;
  }

  return (
    <div className="filter-bar">
      <button
        className={currentFilter === null ? "active" : ""}
        onClick={() => {
          setFilter(null);
        }}
      >
        All ({averageRating.toFixed(1)} <Star />
        <span className="separator">/</span> {numReviews}
        <span className="review-noun">Ratings</span>)
      </button>
      {manager.google && google.count > 0 && (
        <button
          className={currentFilter === "GOOGLEMYBUSINESS" ? "active" : ""}
          onClick={() => {
            setFilter("GOOGLEMYBUSINESS");
          }}
        >
          <PlatformIcon platform="GOOGLEMYBUSINESS" />({google.average.toFixed(1)} <Star />
          <span className="separator">/</span> {google.count}
          <span className="review-noun">Ratings</span>)
        </button>
      )}
      {manager.facebook && facebook.count > 0 && (
        <button
          className={currentFilter === "FACEBOOK" ? "active" : ""}
          onClick={() => {
            setFilter("FACEBOOK");
          }}
        >
          <PlatformIcon platform="FACEBOOK" />({facebook.average.toFixed(1)} <Star /> <span className="separator">/</span> {facebook.count}
          <span className="review-noun">Recommendations & Ratings</span>)
        </button>
      )}
    </div>
  );
};

const Reputation = ({ merchant, writeDisable }) => {
  const { state, dispatch } = useContext(AppContext);
  var hasRep = true;

  if (!merchant.aggregates) {
    hasRep = false;
  }

  let reviewPages = [];
  for (let i = 0; i < state.page; i++) {
    reviewPages.push(
      <ReviewList
        key={`review-page-${i}`}
        page={i + 1}
        filter={state.filter}
        merchant={merchant}
        truncateText={false}
        state={merchant.state}
        noReviewsText={false}
        hidePlatform={!hasRep}
      />
    );
  }

  return (
    <div style={{ marginTop: "2em" }}>
      <ReviewTags merchant={merchant} writeDisable={writeDisable == "true"} />
      <FilterControls
        currentFilter={state.filter}
        setFilter={(filter) => {
          dispatch({ type: "SET_FILTER", payload: filter });
        }}
        merchant={merchant}
      />

      <HeaderText merchant={merchant} />
      <div id="reviews">{reviewPages}</div>
    </div>
  );
};

Reputation.defaultProps = {
  writeDisable: false,
};

export default Reputation;



// WEBPACK FOOTER //
// ./src/containers/All/Reputation.jsx